import {FETCH_STEPS} from "./actions";
import {Widget} from "./types";

const initialState: Widget = null;

export function widgetReducer(
    state = initialState,
    action: any
): Widget {
    switch (action.type) {
        case FETCH_STEPS: {
            return action.payload.widget;
        }
        default:
            return state
    }
}
